import { POST } from '@sisyphe/utils'

/**
 * @description 我的订单-确认收货
 */
export function confirmReceiptUsingPOST(
  params: SwaggerDTO.我的订单确认收货请求对象
): Promise<SwaggerDTO.ResponseResult<void>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/confirmReceipt',
    params
  )
}

/**
 * @description 我的订单-订单详情
 */
export function queryMyOderDetailsUsingPOST(
  params: SwaggerDTO.我的订单查询订单详情请求对象
): Promise<
  SwaggerDTO.ResponseResult<
    SwaggerDTO.我的订单查询订单详情返回对象 & {
      provinceName: string
      cityName: string
      areaName: string
      address: string
    }
  >
> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/queryMyOderDetails',
    params
  )
}

/**
 * @description 我的订单-分页查询-订单状态数量统计
 */
export function queryMyOrderCountUsingPOST(
  params: SwaggerDTO.我的订单查询订单请求对象
): Promise<{ data: Array<SwaggerDTO.我的订单查询订单数量返回对象> }> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/queryMyOrderCount',
    params
  )
}

/**
 * @description 我的订单-分页查询-订单集合
 */
export function queryMyOrdersUsingPOST(
  params: SwaggerDTO.我的订单查询订单请求对象
): Promise<SwaggerDTO.PageResult<SwaggerDTO.我的订单分页查询订单返回对象>> {
  return POST(
    '/enterprise-procurement-client/enterprise/store/queryMyOrders',
    params
  )
}
